/**
 * Portal `$m` / `$s` only — no `AppPortal` or bootstrap. Import via `@/app` (`portal/tsconfig.json`
 * paths + `Bun.build` alias in `frontend/cli/tasks.ts`). Published CMS views resolve the same
 * symbols via `globalThis.__CMS_CATALOG__` (see `cms/lib/catalog`, ADR-038).
 */
import {$m as _$m, $s as _$s} from '@bitstillery/common/app'
import {unchecked} from '@bitstillery/common/lib/unchecked'

import type {State} from '@bitstillery/mithril'
import type {StatePortal} from '@/lib/state'
import {models} from '@/models/models'

export const $m = Object.assign(_$m, models)
// common types the shared state proxy with common's shape; the portal's store holds the portal's.
export const $s = unchecked<State<StatePortal>>(_$s)
